import { lazy, type ComponentType } from "react";

/**
 * `React.lazy` com re-tentativa: um chunk pode falhar por rede instável ou por
 * deploy novo (hash antigo some). Tentamos de novo algumas vezes e, se ainda
 * assim falhar, recarregamos a página uma única vez em vez de mostrar tela branca.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  { retries = 3, delayMs = 400 }: { retries?: number; delayMs?: number } = {},
) {
  return lazy(async () => {
    let lastError: unknown;
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        return await factory();
      } catch (error) {
        lastError = error;
        await new Promise((r) => setTimeout(r, delayMs * (attempt + 1)));
      }
    }

    if (typeof window !== "undefined") {
      const key = "__chunkReloadedAt";
      const last = Number(sessionStorage.getItem(key) ?? 0);
      if (Date.now() - last > 15_000) {
        sessionStorage.setItem(key, String(Date.now()));
        window.location.reload();
        return new Promise<never>(() => {});
      }
    }
    throw lastError;
  });
}
